export const viewQuery = `
SELECT
    atc._id AS id,
    atc.account_id AS account_id,
    atc.completion_date AS completion_date,
    tc.train_id AS train_id,
    tc.name AS course_name
FROM
    account_train_course_cache atc
        LEFT JOIN train_course_cache tc ON atc.course_id = tc._id
`;
